import styled from 'styled-components';
import { Z_INDEX } from '@/config/ui/zIndex';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
export const S = {
    Layout: styled.div `
    display: flex;
    flex-direction: column;
    flex-shrink: 0;

    width: 100%;
    padding: 40px 30px;
  `,
    LayoutPageBody: styled.div `
    display: flex;
    flex-grow: 1;
    flex-direction: column;
  `,
    LayoutSection: styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;

    margin-bottom: ${(props) => (props.isLast ? 0 : '40px')};
  `,
    SectionTitle: styled.div `
    margin-bottom: 20px;

    font-size: 20px;
    font-weight: 500;

    color: ${SEMANTIC_COLORS.DEFAULT_TITLE};
  `,
    /* InfiniteCarousel */
    LayoutInfiniteCarousel: styled.div `
    width: calc(100% + 60px);
  `,
    LayoutSingleSlideCard: styled.div `
    display: flex;
    justify-content: center;
    width: 100%;
  `,
    SlideCard: styled.div `
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    align-self: stretch;

    width: calc(100%);
    padding: ${(props) => (props.isActive ? '18px 20px' : '20px')};
    overflow: hidden;

    background: ${SEMANTIC_COLORS.PRIMARY_CARD_BACKGROUND};
    border: ${(props) => props.isActive
        ? `4px solid ${SEMANTIC_COLORS.PRIMARY_BORDER}`
        : `2px solid ${SEMANTIC_COLORS.PRIMARY_BORDER}`};
    border-radius: 10px;
    box-shadow: ${(props) => (props.isActive ? '2px 8px 15px 5px rgba(56, 55, 53, 0.1)' : 'none')};
  `,
    LayoutSlideCardContent: styled.div `
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;

    width: 100%;

    color: ${SEMANTIC_COLORS.DEFAULT_TEXT};
  `,
    LayoutSlideCardBody: styled.div `
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;

    margin-bottom: 10px;

    & > strong {
      margin-bottom: 8px;
      font-size: 20px;
    }

    & > span {
      font-size: 18px;
      line-height: 26px;
      text-align: justify;
    }
  `,
    LayoutSlideCardFooter: styled.div `
    display: flex;
    justify-content: center;

    width: 100%;
    padding-top: 10px;

    font-size: 18px;
    border-top: 1px solid rgb(93 134 90 / 50%);
  `,
    /* Time Selection Section */
    LayoutCareOrderTimeSelection: styled.div `
    position: relative;
  `,
    LayoutSectionLoading: styled.div `
    position: absolute;
    top: 0;
    left: 0;

    z-index: ${Z_INDEX.LOADING};

    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 100%;

    background: ${SEMANTIC_COLORS.DEFAULT_PAGE_BACKGROUND};
  `,
    LayoutTwoColGrid: styled.div `
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 20px;
    width: 100%;
    height: 63px;
  `,
    LayoutFieldBox: styled.div `
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 20px;

    cursor: pointer;
  `,
    FieldBox: styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 100%;
    min-height: 53px;
    padding: 15px 8px 15px 15px;

    background: ${(props) => props.isError
        ? SEMANTIC_COLORS.ERROR_FIELD_BOX_BACKGROUND
        : SEMANTIC_COLORS.DEFAULT_FIELD_BOX_BACKGROUND};
    border-radius: 10px;
  `,
    FieldBoxValue: styled.div `
    margin-right: 40px;

    font-size: 18px;
    font-weight: 400;
    line-height: 26px;

    color: ${(props) => props.hasValue ? SEMANTIC_COLORS.DEFAULT_TEXT : SEMANTIC_COLORS.PLACEHOLDER_TEXT};
  `,
    FieldBoxFeedbackText: styled.div `
    font-size: 16px;
    line-height: 23px;

    color: ${SEMANTIC_COLORS.ERROR_TEXT};
  `,
    /* allDay */
    LayoutCounterButtons: styled.div `
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;

    opacity: ${(props) => (props.isDisabled ? 0.5 : 1)};

    & > span {
      width: 145px;

      font-size: 32px;
      font-weight: 500;
      color: ${SEMANTIC_COLORS.DEFAULT_TEXT};
      text-align: center;
    }
  `,
    /* partTime */
    LayoutPrevNextButtons: styled.div `
    display: flex;
    align-items: center;
    justify-content: center;

    & > span {
      width: 90px;

      font-size: 32px;
      font-weight: 500;
      color: ${SEMANTIC_COLORS.DEFAULT_TEXT};
      text-align: center;
    }
  `,
    LayoutPartTimeTimeSlotDisplay: styled.div `
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    margin: 20px 0 0;

    font-size: 20px;
    font-weight: 500;
    color: ${SEMANTIC_COLORS.DEFAULT_TEXT};
    text-align: center;

    & > span {
      margin: 0 28px;
    }
  `,
    LayoutFooter: styled.div `
    display: flex;
    justify-content: center;

    width: 100%;
    margin-top: 60px;
  `,
    GapRow: styled.div `
    width: ${(props) => `${props.width}px`};
  `,
};
